import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true, // Temporarily disabled due to Cloudflare CORS caching
  // Using token-based auth instead (stored in localStorage)
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('corpcraft_token');
  // Only add Authorization header if token exists and header not already set
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('corpcraft_token');
      localStorage.removeItem('corpcraft_user');
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
};

export const onboardingApi = {
  complete: (data) => api.post('/onboarding/complete', data),
  getIndustries: () => api.get('/industries'),
};

export const aiApi = {
  analyzeJurisdiction: (data) => api.post('/ai/analyze-jurisdiction', data),
  getRecommendations: () => api.get('/ai/recommendations'),
  applyRecommendation: (id) => api.post(`/ai/apply-recommendation/${id}`),
};

export const entityApi = {
  create: (data) => api.post('/entities', data),
  getAll: () => api.get('/entities'),
  getOne: (id) => api.get(`/entities/${id}`),
  update: (id, data) => api.put(`/entities/${id}`, data),
  delete: (id) => api.delete(`/entities/${id}`),
};

export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
};

export const auditApi = {
  getLogs: (limit = 50) => api.get(`/audit-logs?limit=${limit}`),
};

export default api;
